(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-multi-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector('.cs-hero-grid');
  const left = document.querySelector('.cs-arrow--left');
  const right = document.querySelector('.cs-arrow--right');

  if (!grid || !left || !right) return;

  const slides = Array.from(grid.querySelectorAll('.cs-hero-item, .cs-small-tile'));
  const total = slides.length;

  const updateSlideWidth = () => slides[0]?.clientWidth || grid.clientWidth;
  let slideWidth = updateSlideWidth();

  window.addEventListener('resize', () => (slideWidth = updateSlideWidth()));

  const scrollToSlide = (index) => {
    grid.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
  };

  let current = 0;

  left.addEventListener('click', () => {
    current = Math.max(0, current - 1);
    scrollToSlide(current);
  });

  right.addEventListener('click', () => {
    current = Math.min(total - 1, current + 1);
    scrollToSlide(current);
  });
});

  } catch(e) { console.error(e); }
})();
})();
